import { useState } from "react";
import LocationReportForm from "./reportLocation.js";
import CommentCard from "./commentCard.js"
import CommentForm from "./commentForm.js"
import DeleteWarningForm from './deletewarning.js';
import SuperUserRequestForm from "./superUserRequest.js";
import {BASE_URL} from "../constants"
import { useLanguage } from "../components/Language.js";

function LocationCard({index, location, user, fetchLocationData}){
    
    const [comments, setComments] = useState([]);
    const [isCommentTabVisible, setIsCommentTabVisible] = useState(false);
    const [isReportVisible, setIsReportVisible] = useState(false);
    const [isWarningVisible, setIsWarningVisible] = useState("");
    const [isSuperUserVisible, setIsSuperUserVisible] = useState(false);
    const [isSuperuser, setIsSuperUser] = useState(false);

    const [isEditing, setIsEditing] = useState(false);
    const [isEditingName, setIsEditingName] = useState(false);
    const [isEditingPicture, setIsEditingPicture] = useState(false);
    const [isEditingPostcode, setIsEditingPostcode] = useState(false);
    const [isEditingWebsite, setIsEditingWebsite] = useState(false);
    const [isEditingDescription, setIsEditingDescription] = useState(false);

    const [newName, setNewName] = useState(location.locationName);
    const [newPostcode, setNewPostcode] = useState(location.locationPostcode);
    const [newWebsite, setNewWebsite] = useState(location.locationWebsite);
    const [newDescription, setNewDescription] = useState(location.locationDescription);

    const {language} = useLanguage();

    const translations = {
        en: {
            closeReportForm: "Close report form",
            deleteLocation: "Delete Location",
            saveEdits: "Save Edits",
            invalidPostcode: "Form could not be submitted as you have entered an invalid postcode",
            locationDescription: "Location Description - Enter a little bit of information about the location",
            websiteLink: "Please link to the location website",
            createLocation: "Create Location",
            edit: "Edit",
            save: "Save",
            locationName: "Location Name: ",
            locationPostcode: "Location Postcode",
            checkIns: "Check Ins: ",
            report: "Report",
            closeReport: "Close the report form",
            viewComments: "View Comments",
            hideResponses: "Hide Responses",
            noComments: "This location has no comments yet, write the first!",
            showingAllComments: "Showing All Comments: ",
            
               
        },

        gd: {
            closeReportForm: "Dùin foirm na h-aithisg",
            deleteLocation: "Dubh às an Làrach",
            saveEdits: "Sàbhail Atharrachaidhean",
            invalidPostcode: "Cha ghabhadh an fhoirm a chur a-steach oir tha an  còd-puist mì-dhligheach ",
            locationDescription: "Tuairisgeul Àite - Cuir a-steach beagan mun àite",
            websiteLink: "Dèan ceangal ri làrach-lìn an àite ",
            createLocation: "Cruthaich àite",
            edit: "Deasaich",
            save: "Sàbhail",
            locationName: "Ainm an Àite: ",
            locationPostcode: "Còd-puist Àite",
            checkIns: "Clàraidhean: ",
            report: "Aithris",
            closeReport: "Dùin foirm na h-aithisg",
            viewComments: "Thoir sùil air na h-Abairtean",
            hideResponses: "Falaich na Freagairtean",
            noComments: "Chan eil beachdan ann mun tachartas seo fhathast, sgrìobh a' chiad fhear!",
            showingAllComments: "Taisbeanadh nan abairtean uile: ",
            
        },
    };

    


    const fetchComments = async () => {

        const type = "location"

        console.log("type: ", type)

        try{
            const response = await fetch(
            `${BASE_URL}/api/comments/`,
            {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                },
      
                body: JSON.stringify({
                    type: type,
                    locationName: location.locationName,
                }),
            });
      
            const data = await response.json();
            setComments(data);
    
            setIsCommentTabVisible(true);
      
        } catch (error) {
            console.error('Error fetching comments:', error);
        }
      
    };

    async function performCommentLike(comment_id, username) { 

        await fetch(`${BASE_URL}/api/like_comment/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ comment_id: comment_id, username: username }),
        });
    
    };


    //editing location functions
    const handleUpdateDetail = async (field, newDetail) => {
        
        console.log("details: ", field, newDetail);

        const payload = {
            field, 
            newDetail, 
            "locationName" : location.locationName,
        };

        const response = await fetch(`${BASE_URL}/api/update_location_detail/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
      
            body: JSON.stringify(payload),
        });

        if(field === "name"){
            setIsEditingName(false);
            location.locationName = newDetail;
            fetchLocationData();
        }

        if(field === "description"){
            setIsEditingDescription(false);
            location.locationDescription = newDetail;
            fetchLocationData();
        }

        if(field === "postcode"){
            setIsEditingPostcode(false);
            location.locationPostcode = newDetail;
            fetchLocationData();
        }

        if(field === "website"){
            setIsEditingWebsite(false);
            location.locationWebsite = newDetail;
            fetchLocationData();
        }
    }


    const handlePictureChange = async (e) => {
        const file = e.target.files[0];

        console.log('locationName', location.locationName);
        
        const formData = new FormData();

        formData.append('locationPicture', file);
        formData.append('locationName', location.locationName);

        const response = await fetch(`${BASE_URL}/api/update_location_photo/`, {
            method: 'POST',
            body: formData,
        });

        if (response.ok) {
            const data = await response.json();

            location.locationPicture = data.locationPictureUrl;
            fetchLocationData();
        }
    };


    //delete location function 
    const handleConfirmDelete = async (id) => {
                
        const response = await fetch(`${BASE_URL}/api/delete_location/`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({ location_name:id }),
        });
            
        if (response.ok) {
                  
            console.log(id, "has now been deleted");
            setIsWarningVisible(false);
            fetchLocationData();
        } 
    };



    return(
        <div>
        
            <div key={index} className="event-card">

                <div>
                    {isEditingPicture ? (
                        <input
                            type="file"
                            onChange={handlePictureChange}
                            accept="image/*"
                        />
                    ):(
                        <img id="location-name" style={{ width: '400px', height: 'auto' }} src = {location.locationPicture} alt = "Location_image" />
                    )}

                    {isEditing && (
                        <>
                        {isEditingPicture ? (
                            <button onClick={() => setIsEditingPicture(false)}>{translations[language].save}</button>
                        ):(
                            <button onClick={() => setIsEditingPicture(true)}>{translations[language].edit}</button>
                        )}
                        </>
                    )}
                    
                </div>


                <div>
                    <p>
                        {isEditing && (<> {translations[language].locationName} </>)}
                        {isEditingName ? (
                            <input
                                type = "text"
                                value = {newName}
                                onChange = {(e) => setNewName(e.target.value)}
                            />
                        ):(
                            location.locationName
                        )}
                    </p>
                    
                    {isEditing && (
                        <>
                        {isEditingName ? (
                            <button onClick={() => handleUpdateDetail("name", newName)}>{translations[language].save}</button>
                        ):(
                            <>
                            <button onClick={() => setIsEditingName(true)}>{translations[language].edit}</button>
                            </>
                        )}
                        </>
                    )}

                </div>


                <div>
                    <p>
                        {isEditing && (<> {translations[language].locationDescription} </>)}
                        {isEditingDescription ? (
                            <textarea
                            value = {newDescription}
                            onChange = {(e) => setNewDescription(e.target.value)}
                            rows = "5"
                            cols = "40"
                            style= {{ width: "100%" }}

                            />
                        ):(
                            location.locationDescription
                        )}
                    </p>

                    {isEditing && (
                        <>
                        {isEditingDescription ? (
                            <button onClick={() => handleUpdateDetail("description", newDescription)}>{translations[language].save}</button>
                        ):(
                            <>
                            <button onClick={() => setIsEditingDescription(true)}>{translations[language].edit}</button>
                            </>
                        )}
                        </>
                    )}

                </div>
            

                <div>
                    <p>
                        {isEditing && (<> {translations[language].locationPostcode} </>)}
                        {isEditingPostcode ? (
                            <input
                            type = "text"
                            value = {newPostcode}
                            onChange = {(e) => setNewPostcode(e.target.value)}
                            />
                        ):(
                            location.locationPostcode
                        )}
                    </p>

                    {isEditing && (
                        <>
                        {isEditingPostcode ? (
                            <button onClick={() => handleUpdateDetail("postcode", newPostcode)}>{translations[language].save}</button>
                        ):(
                            <>
                            <button onClick={() => setIsEditingPostcode(true)}>{translations[language].edit}</button>
                            </>
                        )}
                        </>
                    )}
                </div>

                
                <div>

                    <p className="location-website">
                        {isEditing && (<> {translations[language].locationWebsite} </>)}
                        {isEditingWebsite ? (
                            <input
                            type = "text"
                            value = {newWebsite}
                            onChange = {(e) => setNewWebsite(e.target.value)}
                            />
                        ):(
                            location.locationWebsite
                        )}
                    </p>

                    {isEditing && (
                        <>
                        {isEditingWebsite ? (
                            <button onClick={() => handleUpdateDetail("website", newWebsite)}>{translations[language].save}</button>
                        ):(
                            <>
                            <button onClick={() => setIsEditingWebsite(true)}>{translations[language].edit}</button>
                            </>
                        )}
                        </>
                    )}

                </div>
                

                <p>{translations[language].checkIns} {location.locationCheck_ins}</p>
                
                {user && (
                    <>
                    {!isReportVisible ? (
                        <button className="report-loc-button" onClick = {() => setIsReportVisible(!isReportVisible)}>{translations[language].report}</button>
                    ):(
                        <button className="report-loc-button" onClick = {() => setIsReportVisible(!isReportVisible)}>{translations[language].closeReport} </button>
                    )}
                    </>
                )}

                {user && !user.admin && Array.isArray(location.locationSuperusers) && 
                    !location.locationSuperusers.includes(user.username) && (
                        <button 
                            className="superuser-request" 
                            onClick={() => setIsSuperUserVisible(!isSuperUserVisible)}
                        >
                            {isSuperUserVisible 
                                ? "Close superuser form" 
                                : `Request to become a superuser of ${location.locationName}`}
                        </button>
                )}


                {user && (user.admin || (location.locationSuperusers || []).includes(user.username)) && (
                    <button className="delete-location" onClick={() => setIsWarningVisible(!isWarningVisible)}>
                        {translations[language].deleteLocation}
                    </button>
                )}

                {user && (user.admin || (location.locationSuperusers || []).includes(user.username)) && (
                    <button className="edit-location" onClick={() => setIsEditing(!isEditing)}>{isEditing ? `${translations[language].saveEdits}` : `${translations[language].edit}`}</button>
                )}

                {!isCommentTabVisible ? (
                    <button 
                        onClick={() => {
                            if (user && ((location.locationSuperusers || []).includes(user.username))) {
                                setIsSuperUser(true);
                            } else {
                                setIsSuperUser(false);
                            }
                            // setLocationName(location.locationName);
                            fetchComments();
                        }}
                        id = "view-comments-button"
                    >
                        {translations[language].viewComments}
                    </button>
                ):(
                    <button 
                        onClick={() => setIsCommentTabVisible(false)}
                        id = "view-comments-button"
                    >
                        {translations[language].hideResponses}
                    </button>
                )}


                {isSuperUserVisible && user && (
                    <div>
                    <SuperUserRequestForm
                        username = {user.username}
                        locationName ={location.locationName}
                        onClose={() => setIsSuperUserVisible(false)}

                    />
                    </div>
                )}


                {isReportVisible && (
                    <LocationReportForm 
                        locationName = {location.locationName}
                        onClose= {() => setIsReportVisible(false)}
                    />
                )}


                {isWarningVisible && (
                    <div>
                    <DeleteWarningForm
                        deleteInfo={location.locationName}
                        onCancel={() => setIsWarningVisible(false)}
                        onConfirm={() => handleConfirmDelete(location.locationName)}
                    />
                    </div>
                )}


                {isCommentTabVisible && (
                    <div>

                        {comments.length === 0 ? (
                            <p className="no-comments">{translations[language].noComments}</p>
                        ):(
                            <p className="comment-info">{translations[language].showingAllComments} </p>
                        )}


                        {comments.map(comment => {
                            return(

                                <div>
                                <CommentCard 
                                    onclose={setIsCommentTabVisible}
                                    comment_id = {comment.id}
                                    content={comment.content} 
                                    image ={comment.image}
                                    video={comment.video}
                                    date_created={comment.date_created} 
                                    number_likes={comment.likes}
                                    event_name = {comment.location}
                                    author={comment.author}
                                    author_picture={comment.author_picture}
                                    performCommentLike = {performCommentLike}
                                    fetchComments= {fetchComments}
                                    isSuperuser = {isSuperuser}
                                />
                            
                                </div>
                            )
                        })}

                        <CommentForm 
                            type = {"location"}
                            locationName = {location.locationName}
                            comments={comments} 
                            fetchComments = {fetchComments}
                        />

                    </div>
                )}


            </div>


        </div>
    )

};

export default LocationCard;